module.exports = __webpack_public_path__ + "static/media/pub.f94ff8f6.png";